import merge from 'lodash/merge';
import { isUseGlobalConfig } from './is-use-global-config';
/**
 * 全局配置与组件配置合并
 * @param originProps 组件原始props
 * @returns
 */
export function mergeGlobalConfig(originProps) {
    if (!isUseGlobalConfig()) {
        return originProps;
    }
    var globalProps = window === null || window === void 0 ? void 0 : window.__cn_address_global_props__;
    return merge(originProps, globalProps);
}
